export class Page {
  totalItems !: number;
  currentPage!: number;
  pageSize!: number;
  totalPages!: number;
  startPage!: number;
  endPage!: number;
  startIndex!: number;
  endIndex!: number;
  pages!: any[];
  pesquisa!: any;
  ativo!: boolean;
  coluna!: string;
  ordenacao = 'asc';
  dados!: any[];
  filtro!: any;
  dataInicio?: Date;
  dataFim?:Date;
  nR_BPM_BEM_PATRIMONIAL?:number;
}